import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  GrafanaErrorResponse,
  GrafanaSuccessResponse,
  GrafanaPayload,
  createGrafanaDatasourceApi,
} from 'IntegrationModule/api/createGrafanaDatasourceApi';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useNotification } from 'hooks/useNotification';

export const useCreateGrafanaDatasource = () => {
  const token = useSelector(selectAuthToken);
  const { showError } = useNotification();

  const mutation = useMutation<
    AxiosResponse<GrafanaSuccessResponse>,
    AxiosResponse<GrafanaErrorResponse>,
    GrafanaPayload
  >({
    mutationFn: async (params) => {
      if (!token) {
        throw new Error('No auth token available');
      }
      return createGrafanaDatasourceApi({ params, token }) as Promise<
        AxiosResponse<GrafanaSuccessResponse>
      >;
    },
    onError: (error) => {
      // ✅ FIX: Replace alert() with toast notification
      showError(`Grafana datasource creation failed! ${error.data.message}`);
    },
  });
  return {
    createGrafanaDatasource: mutation.mutate,
    isCreatingGrafanaDatasource: mutation.isPending,
  };
};
